@if (current(); as currentEstablishment) {
    <div class="relative">
        @if (isInteractive()) {
            <button
                type="button"
                class="flex w-full items-center gap-2 rounded-lg border border-transparent bg-action-bg px-3 py-2 text-left text-sm font-semibold text-navy transition-colors hover:border-action focus:outline-none focus-visible:border-action focus-visible:ring-2 focus-visible:ring-action"
                aria-haspopup="listbox"
                [attr.aria-expanded]="open()"
                aria-label="Vestiging wisselen"
                (click)="toggle()"
                (keydown)="onTriggerKeydown($event)"
            >
                <app-icon [icon]="buildingIcon" size="table" class="shrink-0 text-action" />
                <span class="min-w-0 flex-1 truncate">{{ currentEstablishment.name }}</span>
                <app-icon
                    [icon]="chevronIcon"
                    size="table"
                    class="shrink-0 text-action transition-transform"
                    [class.rotate-180]="open()"
                />
            </button>
        } @else {
            <!-- Access to a single vestiging: nothing to switch to, so no chevron and no interaction. -->
            <div
                class="flex w-full items-center gap-2 rounded-lg bg-action-bg px-3 py-2 text-sm font-semibold text-navy"
                data-testid="location-switcher-static"
            >
                <app-icon [icon]="buildingIcon" size="table" class="shrink-0 text-action" />
                <span class="min-w-0 flex-1 truncate">{{ currentEstablishment.name }}</span>
            </div>
        }

        @if (open()) {
            <div class="absolute left-0 z-30 mt-1 w-full min-w-64 overflow-hidden rounded-lg border border-border bg-white shadow-lg">
                @if (showSearch()) {
                    <div class="border-b border-border p-2">
                        <div class="flex items-center gap-2 rounded-md border border-border px-2 py-1.5 focus-within:border-action">
                            <app-icon [icon]="searchIcon" size="table" class="shrink-0 text-muted" />
                            <input
                                #searchInput
                                type="text"
                                class="w-full border-0 p-0 text-sm text-ink placeholder:text-muted focus:outline-none focus:ring-0"
                                placeholder="Zoek vestiging..."
                                autocomplete="off"
                                aria-label="Zoek vestiging"
                                [ngModel]="search()"
                                (ngModelChange)="onSearchChange($event)"
                                (keydown)="onListKeydown($event)"
                            />
                        </div>
                    </div>
                }

                <ul
                    role="listbox"
                    aria-label="Vestigingen"
                    [attr.aria-activedescendant]="optionId(activeIndex())"
                    class="max-h-72 overflow-y-auto py-1"
                    tabindex="-1"
                >
                    @for (node of visibleNodes(); track node.establishment.id; let i = $index) {
                        <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
                        <li
                            role="option"
                            [id]="optionId(i)"
                            [attr.aria-selected]="isSelected(node)"
                            [style.padding-left.px]="12 + indentPx(node.depth)"
                            class="flex cursor-pointer items-center gap-2 py-2 pr-3 text-sm"
                            [class.bg-action-bg]="i === activeIndex()"
                            [class.font-semibold]="node.isParent || isSelected(node)"
                            [class.text-action]="isSelected(node)"
                            [class.text-ink]="!isSelected(node)"
                            (click)="select(node)"
                            (mouseenter)="activeIndex.set(i)"
                        >
                            @if (node.depth > 0) {
                                <span class="text-muted" aria-hidden="true">↳</span>
                            }
                            <span class="truncate">{{ node.establishment.name }}</span>
                        </li>
                    }

                    @if (visibleNodes().length === 0) {
                        <li class="px-3 py-3 text-sm text-muted">Geen vestiging gevonden.</li>
                    }
                </ul>
            </div>
        }
    </div>
}
